import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'Fuel/List/', method: 'POST', body: filter, token: token })
}
